import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Link from 'react-router-dom/Link'
import { FALE_CONOSCO_EMAIL } from '../../../../constants/fale-conosco.constants'
import { UserService } from '../../../../services/user.service'
import { routes } from '../../../../constants/routes.constants'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import Title from '../../../../components/typography/title.component'
import AnchorButton from '../../../../components/buttons/anchor-button.component'
import PixInfo from '../../../../components/pix/pix-info.component'

class StorePurchaseSuccess extends Component {
	render() {
		const { orderNumber, pixData } = this.props.location.state
		const { name, email } = this.props.user

		const pixExpiration = pixData
			? new Date(pixData.pixExpiration)
			: new Date()

		const numOfDigits = Math.log10(orderNumber)
		const friendlyOrderNumber = ('000000' + orderNumber).slice(
			-Math.max(6, numOfDigits)
		)

		return (
			<InnerPageContainer small>
				<Title>Obrigado {UserService.getFirstName(name)}!</Title>

				<h3 className="center semi-bold">
					Pedido de compra{' '}
					<span className="blue">{friendlyOrderNumber}</span>
				</h3>

				{pixData.pixLink == null ? (
					<h3 className="center semi-bold orange">
						Sua compra na loja Muviflex está confirmada!
					</h3>
				) : (
					<h3 className="center semi-bold orange">
						Sua solicitação de compra foi recebida!
					</h3>
				)}

				{pixData.pixLink !== null ? (
					<div>
						<h3 className="center semi-bold orange">
							Um e-mail de confirmação será enviado para {email} após a
							confirmação do pagamento.
						</h3>
						<span className="f-x-large">
							<PixInfo
								pixImageQrCode={pixData.qrCodeBase64}
								pixValidity={pixExpiration}
								pixEmv={pixData.emv}
							/>
						</span>
					</div>
				) : (
					<h3 className="center semi-bold orange">
						Um e-mail de confirmação foi enviado para {email}
					</h3>
				)}

				<p className="center">
					Confira suas compras clicando{' '}
					<Link to={`${routes.CLIENTE}/minhas-compras`}>aqui</Link>
				</p>
				{pixData.pixLink !== null ? (
					<span className="f-x-large">
						<p className="f-x-large">
							O não pagamento implica no cancelamento automático da
							compra.
						</p>
					</span>
				) : null}

				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						margin: '4rem auto',
					}}>
					<AnchorButton
						targetBlank
						href="/loja-muviflex"
						style={{ marginBottom: '4rem' }}>
						Loja
					</AnchorButton>
				</div>
				<p className="center">
					Em caso de dúvidas, envie um e-mail para{' '}
					<a href={`mailto:${FALE_CONOSCO_EMAIL}`} className="gray">
						{FALE_CONOSCO_EMAIL}
					</a>
				</p>
			</InnerPageContainer>
		)
	}
}

function mapStateToProps({ user }) {
	return { user }
}

const connectedStorePurchaseSuccess = withRouter(
	connect(mapStateToProps)(StorePurchaseSuccess)
)

export { connectedStorePurchaseSuccess as ModuleRootComponent }
